'use client'
import { createConfigForAuthSession } from '@/features/caching/config/tanstack'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'

export default function LoggedUserRefetchQuery() {
	const queryClient = useQueryClient()
	useEffect(() => {
		queryClient.refetchQueries(createConfigForAuthSession())
	}, [])

	return <></>
}
